import { useEffect } from "react";
import { useNotificationStore } from "../../../common/stores/use-notification-store";
import { getString } from "../../../common/uistringlabels/ui-string-utils";

/** While the order's status is unknown, shows an error banner with the IT Shop HW ticket link. */
export const useUnknownStatusBanner = (isStatusUnknown: boolean): void => {
  const addBanner = useNotificationStore((state) => state.addBanner);
  const removeBanner = useNotificationStore((state) => state.removeBanner);

  useEffect(() => {
    if (!isStatusUnknown) {
      return undefined;
    }
    const bannerId = addBanner({
      type: "error",
      message: getString("orderTracking.states.unknownStatus.message"),
      cti: true,
    });
    return () => removeBanner(bannerId);
  }, [isStatusUnknown, addBanner, removeBanner]);
};
